import React from 'react';
import {makeStringComponent} from '@zvne/fe-framework/dist/presentation/language/strings';
import {Navigation} from '@zvne/fe-framework/dist/presentation/navigation/navigation';
import {LiveScreen} from './screens/live/live-screen';
import {HistoryScreen} from './screens/history/history-screen';
import {ErrorScreen} from './screens/error/error-screen';
import {containerFill, containerFluid, containerStandard} from './screen-hoc';
import {strings} from './strings';
import {Auth} from './reusable/auth/auth-context';

const Str = makeStringComponent(strings);
export const navigation: Navigation<Auth> = {
    tree: [
        {
            label: <Str k={'live'}/>,
            route: '/',
            component: LiveScreen,
            container: containerFill,
            hideBreadcrumbs: true,
            authGuard: auth => auth.hasRole('user')
        },
        {
            label: <Str k={'history'}/>,
            route: '/history',
            component: HistoryScreen,
            container: containerFluid,
            hideBreadcrumbs: true,
            authGuard: auth => auth.hasRole('user')
        }
    ],
    fallback: {
        component: ErrorScreen,
        container: containerStandard
    }
};
